module.exports = __webpack_public_path__ + "static/media/referral-program-hero.1fa23459.jpg";